import React, { Component } from 'react'
import classnames from 'classnames'

import styles from './styles/progress-bar-counter.scss'

export default class ProgressBar extends Component {
  render() {
    const progress = this.props.current / this.props.max * 100

    return (
      <div className={styles.barContainer}>
        <div className={styles.bar} style={{ width: `${progress}%` }} />

        <div
          className={classnames(styles.number, {
            [styles.numberRight]: progress <= 50,
            [styles.numberLeft]: progress > 50
          })}
          style={{ left: `${progress}%` }}
        >
          {Math.round(progress)} %
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ProgressBar.js